module.exports = __webpack_public_path__ + "6cc1404b888a5aca35f63b9d2c2cb0dd.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/cloud-types.png
// module id = 250
// module chunks = 1